export default "__VITE_ASSET__074adc90__"